module.exports = __webpack_public_path__ + "static/scrap-5ba8257d2de944e939ec7221620a513c.jpg";